export const LOCATION = 'location'
export const TEMPERATURE = 'temperature'
export const FORECAST_RANGE = 'forecast_range'

export const getTriggerInitialValues = (trigger = {}) => ({
  [LOCATION]: trigger[LOCATION] || '',
  [TEMPERATURE]: trigger[TEMPERATURE] || '',
  [FORECAST_RANGE]: trigger[FORECAST_RANGE] || ''
})
